The name of the field that caused the issue.

For example, "positionLocation.city".
